<template>
  <v-card elevation="0">
    <v-card-title> Отчет </v-card-title>
    <v-card-text>
      <div class="text-subtitle-2 black--text">
        Проверьте все параметры загрузки, при необходимости что-то изменить
        вернитесь назад.
        <br />
        Если все верно - приступайте к загрузке.
      </div>
      <v-list-group no-action prepend-icon="mdi-cogs" :value="true">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              v-text="`Общие настройки загрузки`"
            ></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="(option, i) in optionsList"
          :key="option.text"
          :style="i % 2 == 0 ? '' : 'background-color:#F5F5F5'"
        >
          <v-list-item-title>
            {{ option.text }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ option.val }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list-group>
      <v-list-group no-action prepend-icon="mdi-ruler" :value="true">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              v-text="`Список единиц измерения`"
            ></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item>
          <v-list-item-title class="black--text text-h6">
            Ед. измерения из файла
          </v-list-item-title>
          <v-list-item-subtitle class="black--text text-h6">
            Ед. измерения SH
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item
          v-for="(unit, i) in units"
          :key="unit.name"
          class="text--primary text-uppercase mb-2 mt-2"
          :style="i % 2 == 0 ? '' : 'background-color:#F5F5F5'"
        >
          <v-list-item-title> {{ unit.name }} </v-list-item-title>
          <v-list-item-subtitle>
            {{ unitText(unit.rid) }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list-group>
      <v-card-subtitle>
        <v-icon>mdi-food</v-icon>
        Список товаров (Товаров: {{fileData.slice(skip).length}})
      </v-card-subtitle>
      <v-virtual-scroll height="300px" item-height="50px" :items="fileData.slice(skip)">
        <template #default="{item, index}">
          <v-list-item
            :key="index"
            :style="index % 2 == 0 ? '' : 'background-color:#F5F5F5'"
            class="mb-2 mt-2"
          >
            <v-list-item-title class="text--primary text-uppercase">
              {{ index + 1 }}. {{ item[columns.name] }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-uppercase text-wrap">
              Ед.измерения:
              {{
                item[columns.unitName].trim()
                  ? item[columns.unitName]
                  : `По умолчанию (${defaultUnit})`
              }}
              <div v-if="uploadOptions.uploadCals">
                {{ caloryInfo(index) }}
              </div>
              <div v-if="uploadOptions.uploadMinMaxAmounts">
                {{ amountsInfo(index) }}
              </div>
              <div v-if="uploadOptions.uploadPrecent">
                {{ precnetlesInfo(index) }}
              </div>
              <div>
                <strong class="red--text">{{ uploadInfo(i) }}</strong>
              </div>
            </v-list-item-subtitle>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    expandedGeneral: false,
    expandedUnits: false,
    flatGoods: [],
  }),
  computed: {
    ...mapGetters([
      "aCategories",
      "gCategories",
      "gGroups",
      "SHUnits",
      "uploadOptions",
      "units",
      "fileData",
      "columns",
      "skip",
      "pathSep",
    ]),
    aCat() {
      return this.aCategories.find(
        (e) => e.rid == this.uploadOptions.accountingCategoryRid
      ).name;
    },
    gCat() {
      return this.gCategories.find(
        (e) => e.rid == this.uploadOptions.goodsCategoryRid
      ).name;
    },
    defaultUnit() {
      return this.SHUnits.find(
        (e) => e.rid == this.uploadOptions.defaultUnitRid
      ).name;
    },
    optionsList() {
      return [
        {
          text: "Загрузка калорий",
          val: this.uploadOptions.uploadCals ? "Да" : "Нет",
        },
        {
          text: "Загрузка остатков",
          val: this.uploadOptions.uploadMinMaxAmounts ? "Да" : "Нет",
        },
        {
          text: "Загрузка процентов обработки",
          val: this.uploadOptions.uploadPrecent ? "Да" : "Нет",
        },
        { text: "Категория товаров", val: this.gCat },
        { text: "Бухгалтерская категория товаров", val: this.aCat },
        {
          text: "Родительская группа товаров",
          val: this.find(this.gGroups, this.uploadOptions.groupRootRid).name,
        },
        { text: "Разделитель путей по группам", val: this.pathSep },
        { text: "Единица измерения по умолчанию", val: this.defaultUnit },
      ];
    },
  },
  methods: {
    unitText(rid) {
      if (rid == null) {
        return `${this.defaultUnit} (По Умолчанию)`;
      }
      let found = this.SHUnits.find((e) => e.rid == rid);
      return found.name;
    },
    caloryInfo(idx) {
      return `
        Ж:${this.fileData[idx + this.skip][this.columns.fats] || "0"} 
        Б:${this.fileData[idx + this.skip][this.columns.proteins] || "0"} 
        У:${this.fileData[idx + this.skip][this.columns.carbs] || "0"}
      `;
    },
    amountsInfo(idx) {
      return `
        Мин. остаток:${
          this.fileData[idx + this.skip][this.columns.min] || "0"
        }  
        Макс. остаток:${this.fileData[idx + this.skip][this.columns.max] || "0"}
    `;
    },
    precnetlesInfo(idx) {
      return `1%:${
        this.fileData[idx + this.skip][this.columns.precentle1] || "0"
      } 2%:${this.fileData[idx + this.skip][this.columns.precentle2] || "0"}`;
    },
    find(groups, rid) {
      for (const group of groups) {
        if (group.rid == rid) return group;
        let found = this.find(group.child_groups, rid);
        if (found) {
          return found;
        }
      }
      return null;
    },
    flattenGoods(groups) {
      for (const group of groups) {
        for (const good of group.goods) {
          this.flatGoods.push(good);
        }
        this.flattenGoods(group.child_groups);
      }
    },
    uploadInfo(idx) {
      return this.flatGoods.at(idx)
        ? this.flatGoods.at(idx).upload
          ? ""
          : "не будет загружен"
        : "";
    },
  },
  beforeMount() {
    this.flattenGoods(this.$store.getters.toUploadGroups);
  },
};
</script>